import * as React from 'react';
import { cn } from '@/core/lib/utils';

interface SeverityIndicatorProps {
  severity: number | string;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const severityConfig: Record<number, { label: string; color: string; bgColor: string }> = {
  1: { label: 'Minimal', color: 'text-green-700', bgColor: 'bg-green-100' },
  2: { label: 'Mild', color: 'text-lime-700', bgColor: 'bg-lime-100' },
  3: { label: 'Moderate', color: 'text-yellow-700', bgColor: 'bg-yellow-100' },
  4: { label: 'Significant', color: 'text-orange-700', bgColor: 'bg-orange-100' },
  5: { label: 'Severe', color: 'text-red-700', bgColor: 'bg-red-100' },
};

const sizeClasses = {
  sm: 'h-2 w-2',
  md: 'h-3 w-3',
  lg: 'h-4 w-4',
};

const textSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
};

export function SeverityIndicator({ 
  severity, 
  showLabel = false, 
  size = 'md',
  className 
}: SeverityIndicatorProps) {
  const severityNum = typeof severity === 'string' ? parseInt(severity, 10) : severity;
  const config = severityConfig[severityNum] || severityConfig[3];

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span 
        className={cn(
          'rounded-full',
          sizeClasses[size],
          config.bgColor,
          config.color
        )} 
      />
      {showLabel && (
        <span className={cn(textSizeClasses[size], config.color, 'font-medium')}>
          {config.label}
        </span>
      )}
    </div>
  );
}

export default SeverityIndicator;
